import "./styles/global.scss"
import { useState } from "react";
import { Home } from "./pages/home/Home"
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate
} from "react-router-dom"
import AuthGuard from "./components/AuthGuard"
import Products from "./pages/products/Products";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Menu from "./components/menu/Menu";
import Login from "./pages/login/Login";
import { CreateOrder } from "./pages/order/create/CreateOrder";
import { OrderIndex } from "./pages/order/index/order";
import { OrderDetails } from "./pages/order/details/Details";
import { EditOrder } from "./pages/order/edit/EditOrder";
import { Configuration } from "./pages/Settings/Configurations/Configuration";
import { CreateDangerousItem } from "./pages/dangerousitems/create/CreateDangerousItem";
import { EditDangerousItem } from "./pages/dangerousitems/edit/EditDangerousItem";
import { DangerousItemIndex } from "./pages/dangerousitems/list/DangerousItemIndex";
import { CreateMeasurementUnit } from "./pages/measurementunits/create/CreateMeasurementUnit";
import { EditMeasurementUnit } from "./pages/measurementunits/edit/EditMeasurementUnit";
import { MeasurementUnitIndex } from "./pages/measurementunits/list/MeasurementUnitIndex";
import { CreatePaymentMethod } from "./pages/paymentmethods/create/CreatePaymentMethod";
import { EditPaymentMethod } from "./pages/paymentmethods/edit/EditPaymentMethod";
import { PaymentMethodIndex } from "./pages/paymentmethods/list/PaymentMethodIndex";
import { ShippingCompanyIndex } from "./pages/shippingcompanyies/index/ShippingCompanyIndex";
import { CreateShippingCompany } from "./pages/shippingcompanyies/create/CreateShippingCompany";
import { EditShippingCompany } from "./pages/shippingcompanyies/edit/EditShippingCompany";
import { CreateCurrency } from "./pages/currency/create/CreateCurrency";
import { EditCurrency } from "./pages/currency/edit/EditCurrency";
import { CurrencyIndex } from "./pages/currency/list/CurrencyIndex";
import { CreateVoucher } from "./pages/vouchers/create/CreateVoucher";
import { EditVoucher } from "./pages/vouchers/edit/EditVoucher";
import { VoucherIndex } from "./pages/vouchers/list/VoucherIndex";
import { CreateCategory } from "./pages/categories/create/CreateCategory";
import { EditCategory } from "./pages/categories/edit/EditCategory";
import { CategoryIndex } from "./pages/categories/list/CategoryIndex";
import { CountryIndex } from "./pages/country/list/CountryIndex";
import { CreateCountry } from "./pages/country/create/CreateCountry";
import { EditCountry } from "./pages/country/edit/EditCountry";
import CityIndex from "./pages/cities/index/CityIndex";
import CreateCity from "./pages/cities/create/CreateCity";
import EditCity from "./pages/cities/edit/EditCity";
import { CustomerDetails } from "./pages/customers/Details";
import { ShipForMeIndex } from "./pages/shipforme/index/Order";
import { ShipForMeDetails } from "./pages/shipforme/details/Details";
import EditShipForMe from "./pages/shipforme/edit/EditShipForMe";
import PrintInvoice from "./pages/order/print/PrintInvoice";
import { CustomerIndex } from "./pages/customers/CustomerIndex";
import { EditProfile } from "./pages/customers/update/EditProfile";
import { EditUser } from "./pages/users/update/EditUser";
import { UserIndex } from "./pages/users/UserIndex";
import { CreateUser } from "./pages/users/create/CreateUser";
import { UserLogs } from "./pages/users/UserLogs";
import { EditUserAddress } from "./pages/useraddress/edit/EditUserAddress";
import { RoleIndex } from "./pages/roles/list/RoleIndex";
import { CreateRole } from "./pages/roles/create/CreateRole";
import { EditRole } from "./pages/roles/edit/EditRole";
import PrintInvoiceShipForMe from "./pages/shipforme/print/PrintInvoiceShipForMe";
import { CreateProfile } from "./pages/customers/create/CreateProfile";
import { InvoiceIndex } from "./pages/invoice/list/InvoiceIndex";
import { CreateInvoice } from "./pages/invoice/create/CreateInvoice";
import { EditInvoice } from "./pages/invoice/edit/EditInvoice";
import { OrderCalculator } from "./pages/calculator/order/OrderCalculator";
import { ShipForMeCalculator } from "./pages/calculator/shipforme/ShipForMeCalculator";
import { FaqIndex } from "./pages/faq/list/FaqIndex";
import { CreateFaq } from "./pages/faq/create/CreateFaq";
import { EditFaq } from "./pages/faq/edit/EditFaq";
import { FaqCategoryIndex } from "./pages/faq-category/list/FaqCategoryIndex";
import { CreateFaqCategory } from "./pages/faq-category/create/CreateFaqCategory";
import { EditFaqCategory } from "./pages/faq-category/edit/EditFaqCategory";
import { PaymentGatewayIndex } from "./pages/payment-gateways/list/PaymentGatewayIndex";
import { CreatePaymentGateway } from "./pages/payment-gateways/create/CreatePaymentGateway";
import { EditPaymentGateway } from "./pages/payment-gateways/edit/EditPaymentGateway";
import { ContactRequestIndex } from "./pages/contact-requests/list/ContactRequestIndex";
import { RecoveryPage } from "./pages/recovery/RecoveryPage";
import { SliderIndex } from "./pages/cms/sliders/SliderIndex";
import { CreateSlider } from "./pages/cms/sliders/CreateSlider";
import { EditSlider } from "./pages/cms/sliders/EditSlider";
import { GeneralInfo } from "./pages/cms/general-info/GeneralInfo";
import RecaptchaSettings from "./pages/recaptcha-settings/RecaptchaSettings";
import { TaxProfiles } from "./pages/tax-profiles/TaxProfiles";
import { BuyForMeGroupDetails, BuyForMeGroupIndex } from "./pages/order-groups/BuyForMeGroups";
import { ShipForMeGroupDetails, ShipForMeGroupIndex } from "./pages/order-groups/ShipForMeGroups";


// Move Layout component outside App to prevent recreation on every render
const Layout = () => {
  console.log('🔄 Layout component rendering');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <AuthGuard>
      <div className="main">
        <Navbar isSidebarOpen={isSidebarOpen} onToggleSidebar={handleToggleSidebar} />
        <div className="container" style={{ maxWidth: "100%" }}>
          <div className={`menuContainer ${isSidebarOpen ? 'open' : 'closed'}`}>
            <Menu />
          </div>
          <div className="contentContainer">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </AuthGuard>
  );
};

// Move AuthLayout outside App to prevent recreation on every render.
const AuthLayout = () => {
  console.log('🔄 AuthLayout component rendering');
  return (
    <div className="auth-layout">
      <Outlet />
    </div>
  );
};

// Move router configuration outside App to prevent recreation on every render
console.log('🔄 Router configuration created (this should only happen once)');
const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/products",
        element: <Products />,
      },
      {
        path: "/order/create",
        element: <CreateOrder />,
      },
      {
        path: "/order",
        element: <OrderIndex />,
      },
      {
        path: "/order/index",
        element: <OrderIndex />,
      },
      {
        path: "/buyforme-groups",
        element: <BuyForMeGroupIndex />,
      },
      {
        path: "/buyforme-groups/:id",
        element: <BuyForMeGroupDetails />,
      },
      {
        path: "/shipforme-groups",
        element: <ShipForMeGroupIndex />,
      },
      {
        path: "/shipforme-groups/:id",
        element: <ShipForMeGroupDetails />,
      },
      {
        path: "/order/details/:id",
        element: <OrderDetails />,
      },
      {
        path: "/order/:id",
        element: <OrderDetails />,
      },
      {
        path: "/order/print/:id",
        element: <PrintInvoice />,
      },
      {
        path: "/order/printinvoice/:id",
        element: <PrintInvoice />,
      },
      {
        path: "/order/edit/:id",
        element: <EditOrder />,
      },
      {
        path: "/calculator/order",
        element: <OrderCalculator />,
      },
      {
        path: "/calculator/shipforme",
        element: <ShipForMeCalculator />,
      },
      {
        path: "/shipforme",
        element: <ShipForMeIndex />,
      },
      {
        path: "/shipforme/details/:id",
        element: <ShipForMeDetails />,
      },
      {
        path: "/shipforme/edit/:id",
        element: <EditShipForMe />,
      },
      {
        path: "/shipforme/print/:id",
        element: <PrintInvoiceShipForMe />,
      },
      {
        path: "/shipforme/printinvoice/:id",
        element: <PrintInvoiceShipForMe />,
      },
      {
        path: "/config",
        element: <Configuration />,
      },
      {
        path: "/dangerous-items/create",
        element: <CreateDangerousItem />,
      },
      {
        path: "/dangerous-items/edit/:id",
        element: <EditDangerousItem />,
      },
      {
        path: "/dangerous-items",
        element: <DangerousItemIndex />,
      },
      {
        path: "/measurement-units/create",
        element: <CreateMeasurementUnit />,
      },
      {
        path: "/measurement-units/edit/:id",
        element: <EditMeasurementUnit />,
      },
      {
        path: "/measurement-units",
        element: <MeasurementUnitIndex />,
      },
      {
        path: "/payment-methods/create",
        element: <CreatePaymentMethod />,
      },
      {
        path: "/payment-methods/edit/:id",
        element: <EditPaymentMethod />,
      },
      {
        path: "/payment-methods",
        element: <PaymentMethodIndex />,
      },

      {
        path: "/categories/create",
        element: <CreateCategory />,
      },
      {
        path: "/categories/edit/:id",
        element: <EditCategory />,
      },
      {
        path: "/categories",
        element: <CategoryIndex />,
      },
      {
        path: "/currencies/create",
        element: <CreateCurrency />,
      },
      {
        path: "/currencies/edit/:id",
        element: <EditCurrency />,
      },
      {
        path: "/currencies",
        element: <CurrencyIndex />,
      },
      {
        path: "/vouchers/create",
        element: <CreateVoucher />,
      },
      {
        path: "/vouchers/edit/:id",
        element: <EditVoucher />,
      },
      {
        path: "/vouchers",
        element: <VoucherIndex />,
      },
      {
        path: "/shipping-companies",
        element: <ShippingCompanyIndex />,
      },
      {
        path: "/shipping-companies/create",
        element: <CreateShippingCompany />,
      },
      {
        path: "/shipping-companies/edit/:id",
        element: <EditShippingCompany />,
      },
      {
        path: "/tax-profiles",
        element: <TaxProfiles />,
      },
      {
        path: "/countries",
        element: <CountryIndex />,
      },
      {
        path: "/countries/create",
        element: <CreateCountry />,
      },
      {
        path: "/countries/edit/:id",
        element: <EditCountry />,
      },
      {
        path: "/cities",
        element: <CityIndex />,
      },
      {
        path: "/cities/create",
        element: <CreateCity />,
      },
      {
        path: "/cities/edit/:id",
        element: <EditCity />,
      },
      {
        path: "/faqs",
        element: <FaqIndex />,
      },
      {
        path: "/faqs/create",
        element: <CreateFaq />,
      },
      {
        path: "/faqs/edit/:id",
        element: <EditFaq />,
      },
      {
        path: "/faq-categories",
        element: <FaqCategoryIndex />,
      },
      {
        path: "/faq-categories/create",
        element: <CreateFaqCategory />,
      },
      {
        path: "/faq-categories/edit/:id",
        element: <EditFaqCategory />,
      },
      {
        path: "/payment-gateways",
        element: <PaymentGatewayIndex />,
      },
      {
        path: "/payment-gateways/create",
        element: <CreatePaymentGateway />,
      },
      {
        path: "/payment-gateways/edit/:id",
        element: <EditPaymentGateway />,
      },
      {
        path: "/roles",
        element: <RoleIndex />,
      },
      {
        path: "/roles/create",
        element: <CreateRole />,
      },
      {
        path: "/roles/edit/:id",
        element: <EditRole />,
      },
      {
        path: "/customers/:id",
        element: <CustomerDetails />,
      },
      {
        path: "/customers/edit/:id",
        element: <EditProfile />,
      },
      {
        path: "/customers/create",
        element: <CreateProfile />,
      },
      {
        path: "/customers",
        element: <CustomerIndex />,
      },
      {
        path: "/users/edit/:id",
        element: <EditUser />,
      },
      {
        path: "/users/create",
        element: <CreateUser />,
      },
      {
        path: "/users/logs/:userId",
        element: <UserLogs />,
      },
      {
        path: "/users",
        element: <UserIndex />,
      },
      {
        path: "/useraddresses/edit/:id",
        element: <EditUserAddress />,
      },
      {
        path: "/invoices",
        element: <InvoiceIndex />,
      },
      {
        path: "/invoices/create/:orderType/:id",
        element: <CreateInvoice />,
      },
      {
        path: "/invoices/edit/:id",
        element: <EditInvoice />,
      },
      {
        path: "/contact-requests",
        element: <ContactRequestIndex />,
      },
      {
        path: "/settings/recaptcha",
        element: <RecaptchaSettings />,
      },
      {
        path: "/cms/sliders",
        element: <SliderIndex />,
      },
      {
        path: "/cms/sliders/create",
        element: <CreateSlider />,
      },
      {
        path: "/cms/sliders/edit/:id",
        element: <EditSlider />,
      },
      {
        path: "/cms/general-info",
        element: <GeneralInfo />,
      },
      {
        path: "/recovery",
        element: <RecoveryPage />,
      },
    ],
  },
  {
    path: "/auth",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <Login />,
      },
    ],
  },
  // Redirect old auth routes to new structure
  {
    path: "/login",
    element: <Navigate to="/auth/login" replace />,
  },
  {
    path: "/signup",
    element: <Navigate to="/auth/signup" replace />,
  },
  {
    path: "/forgotpassword",
    element: <Navigate to="/auth/forgotpassword" replace />,
  },
]);

function App() {
  console.log('🔄 App component rendering');
  return <RouterProvider router={router} />
}

export default App
